import { ref } from 'vue';

export type ConfirmVariant = 'danger' | 'warning' | 'default';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: ConfirmVariant;
}

interface ConfirmState extends ConfirmOptions {
  visible: boolean;
  resolve: ((value: boolean) => void) | null;
}

const state = ref<ConfirmState>({
  visible: false,
  title: 'Confirm',
  message: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  variant: 'default',
  resolve: null,
});

function close(result: boolean): void {
  if (!state.value.visible) return;
  const resolve = state.value.resolve;
  state.value.visible = false;
  state.value.resolve = null;
  resolve?.(result);
}

function confirm(options: ConfirmOptions | string): Promise<boolean> {
  if (state.value.visible) {
    close(false);
  }

  const opts = typeof options === 'string' ? { message: options } : options;

  return new Promise<boolean>((resolve) => {
    state.value = {
      visible: true,
      title: opts.title ?? 'Confirm',
      message: opts.message,
      confirmText: opts.confirmText ?? 'Confirm',
      cancelText: opts.cancelText ?? 'Cancel',
      variant: opts.variant ?? 'default',
      resolve,
    };
  });
}

export function useConfirm() {
  return {
    state,
    confirm,
    accept: () => close(true),
    cancel: () => close(false),
  };
}
